import { capitalize } from '@insurancemenu/imenu-components-lib/dist/helpers';

export const convertTag = (status: string): string => {
  return status
    .toLowerCase()
    .split('_')
    .map((tagStatus) => capitalize(tagStatus))
    .join(' ');
};
